<template>
  <v-container>
    <v-img
      src="culColour"
      class="logo"
      position="left top"
    />
    <DataProtection />
    <v-btn
      v-if="canGoBack"
      @click="goBack"
    >
      GO BACK
    </v-btn>
  </v-container>
</template>

<script>
import culColour from "@/assets/cul_colour.png";
import DataProtection from "@/components/DataProtection.vue";

export default {
  components: {
    DataProtection
  },
  data: () => ({
    dialog: false,
    culColour
  }),
  computed: {
    canGoBack () {
      try {
        const s = this.$router?.options?.history?.state
        // vue-router sets .back when there is a previous entry; .position > 0 also indicates history
        return !!(s && (s.back || s.position > 0))
      } catch (e) {
        console.error(e)
        return window.history.length > 1
      }
    },
  },
  methods: {
    cancelUpload () {
      this.dialog = false
    },
    goBack () {
      if (window.history.length > 1) this.$router.back()
      else this.$router.push({ name: 'WelcomePage' }) // fallback if no history
    },
  }
}
</script>

<style>
.logo {
  margin-bottom: 20px;
  max-height: 50px;
}
</style>
